import { useState } from 'react';
import { List } from 'antd';
import BindLinkButton from '../../components/BindLinkButton';
import { UserEmail, ProviderTags, RoleSelect } from './UserFields';
import type { ManagedUser } from './users.constants';

const PAGE_SIZE = 10;

interface Props {
  users: ManagedUser[];
  loading: boolean;
  onRoleChange: (id: string, roleId: string) => void;
  onEmailChange: (id: string, email: string) => void;
}

/** 手機版帳號列表：每位使用者一張卡片（名稱 + 角色 / email / 登入方式 + 綁定連結）。 */
export default function UserCardList({ users, loading, onRoleChange, onEmailChange }: Props) {
  const [page, setPage] = useState(1);
  return (
    <List
      loading={loading}
      dataSource={users}
      rowKey="id"
      split={false}
      pagination={
        users.length > PAGE_SIZE
          ? { simple: true, current: page, pageSize: PAGE_SIZE, onChange: setPage, align: 'center' }
          : false
      }
      renderItem={(u) => (
        <li className="mb-3 rounded-xl border border-black/[0.06] bg-white p-3 shadow-sm">
          <div className="flex items-center justify-between gap-2">
            <span className="min-w-0 truncate text-[15px] font-medium">{u.displayName}</span>
            <div className="shrink-0">
              <RoleSelect roles={u.roles} width={150} onChange={(roleId) => onRoleChange(u.id, roleId)} />
            </div>
          </div>
          <UserEmail
            email={u.email}
            className="mt-1.5 block break-all text-[13px]"
            onChange={(v) => onEmailChange(u.id, v)}
          />
          <div className="mt-2 flex flex-wrap items-center gap-y-2">
            <ProviderTags providers={u.providers} />
            <div className="ml-auto">
              <BindLinkButton userId={u.id} displayName={u.displayName} />
            </div>
          </div>
        </li>
      )}
    />
  );
}
